module.exports = __webpack_public_path__ + "img/reset.0e89c7da.svg";